export var EditContentElementTypes;
(function (EditContentElementTypes) {
    EditContentElementTypes["RegionsEditor"] = "regions-editor";
    EditContentElementTypes["RegionsSelection"] = "regions-selection";
    EditContentElementTypes["TwoImagesToggle"] = "two-images-toggle";
})(EditContentElementTypes || (EditContentElementTypes = {}));
//# sourceMappingURL=edit-content-element-types.types.js.map